module.exports = __webpack_public_path__ + "media/images/shop/logo-meet-33694f458ff6b47325148aa6912dbe3a.png";